import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from './skeleton.component';
import { SkeletonGroup } from './skeleton_group.component';
export const SkeletonLines = ({ count = 3, lastLineWidth, lineHeight = '1rem', gap = 2, className = '', dataTestId, }) => {
    const lines = Array.from({ length: count }, (_, i) => i);
    return (_jsx(SkeletonGroup, { gap: gap, className: className, dataTestId: dataTestId, children: lines.map((i) => (_jsx(Skeleton, { variant: 'line', width: i === count - 1 ? lastLineWidth : undefined, height: lineHeight }, i))) }));
};
//# sourceMappingURL=skeleton_lines.component.js.map